import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import InsertHtml from '../../components/insertHtml';
import Nav from '@ifeng-fe/container_channel/common/client/winter/components/nav';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';

/**
 * 定义 Header 组件
 */
class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const topNav = (
            <div className={styles.main_nav_wrap} key="topNav">
                <div id="main_nav" className={styles.main_nav}>
                    <Chip id="20002" type="struct" title="导航" groupName="头部" content={content.nav}>
                        <Nav />
                    </Chip>
                    <div className={styles.user}>
                        <UserInfo />
                    </div>
                </div>
            </div>
        );
        const topAd = (
            <div key="topAd" className={styles.ad}>
                {/* <Ad content={content.topAd} styleName={styles.box} /> */}
            </div>
        );
        const logo = (
            <div className={styles.logo} key="logo">
                <Chip id="30044" type="static" title="Logo" groupName="头部" content={content.logo}>
                    <InsertHtml />
                </Chip>
            </div>
        );

        return [topNav, topAd, logo];
    }
}

export default errorBoundary(Header);
